// ========================================================
//  VARIANT ENGINE — jedini JS koji upravlja varijantama
// ========================================================

window.currentSelectedOptions = [];
window.productVariantsData = window.productVariantsData || [];

// --------------- Find variant by options array ---------------
window.findVariant = function(options) {
  return window.productVariantsData.find(v =>
    v.options.every((opt, i) => opt == options[i])
  );
};

// --------------- Apply a Shopify variant everywhere ---------------
window.selectVariant = function(variant) {
  if (!variant) return;

  // 1) Update URL
  const newUrl = `${location.pathname}?variant=${variant.id}`;
  history.replaceState({}, "", newUrl);

  // 2) Update every PDP variant field so add-to-cart stays aligned on first load
  document.querySelectorAll('input[name="id"]').forEach(inp => {
    inp.value = variant.id;
    inp.setAttribute('value', variant.id);
    inp.dispatchEvent(new Event('change', { bubbles: true }));
  });

  document.querySelectorAll('select[name="id"]').forEach(sel => {
    sel.value = String(variant.id);
    sel.querySelectorAll('option').forEach(opt => {
      opt.selected = String(opt.value) === String(variant.id);
    });
  });

  // 3) Update media gallery
  if (variant.featured_media?.id) {
    document.dispatchEvent(new CustomEvent("product:media:select", {
      detail: { mediaId: variant.featured_media.id }
    }));
  }

  // 4) Update price (section = main)
  /*fetch(`${location.pathname}?variant=${variant.id}&section_id=main`)
    .then(r => r.text())
    .then(html => {
      const doc = new DOMParser().parseFromString(html, "text/html");
      const updated = doc.querySelector("#price-main");
      if (updated) {
        document.querySelector("#price-main").innerHTML = updated.innerHTML;
      }
    });*/

  // 5) Update Add to Cart button
  const btn = document.querySelector('[name="add"]');
  const btnText = btn?.querySelector("span");
  if (btn && btnText) {
    if (variant.available) {
      btn.disabled = false;
      btnText.textContent = "Add to cart";
    } else {
      btn.disabled = true;
      btnText.textContent = "Sold out";
    }
  }

  // 6) Save state
  window.currentSelectedOptions = [...variant.options];
  window.__lastVariantChange = variant;
};

// --------------- Initialize on load ---------------
document.addEventListener("DOMContentLoaded", () => {
  const initialVariantId = new URLSearchParams(location.search).get("variant");
  let initial = window.productVariantsData.find(v => v.id == initialVariantId);

  if (!initial) {
    // fallback to first available
    initial = window.productVariantsData.find(v => v.available) || window.productVariantsData[0];
  }

  if (initial) {
    window.currentSelectedOptions = [...initial.options];
    window.selectVariant(initial);
  }
});
